import { render, staticRenderFns } from "./Shifts.vue?vue&type=template&id=606b792e&scoped=true&"
import script from "./Shifts.vue?vue&type=script&lang=js&"
export * from "./Shifts.vue?vue&type=script&lang=js&"
import style0 from "./Shifts.vue?vue&type=style&index=0&id=606b792e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606b792e",
  null
  
)

export default component.exports